import { AIEffectiveSettingsMessage } from './ai.rooms';
import { TenantNotificationPayload } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

export const TenantRoomEventType = {
    MaintenanceMode: 'maintenance-mode',
} as const;

export type TenantRoomMessage = TenantNotificationPayload | AIEffectiveSettingsMessage;

export const TenantRooms = {
    tenant: (tenantKey: string): RoomKey<TenantRoomMessage> => ({ key: tenantKey }),
};
